export const selectOffers = (state) => state.offersReducer.offer;
export const selectHotOffers = (state) => state.offersReducer.hotOffers;
export const selectHotOfferById = (state) => state.offersReducer.hotOffer;